<div class="progress-loader">
    <div class="loading-spinner">
         <img src="assets/img/loading.gif">
    </div>
</div>